import styled from 'styled-components';

import { fadeIn } from '../../../styles/shared.style';

export const Wrapper = styled.section<{ $position: number, $showContent: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  margin-bottom: ${({ $position, $showContent }) => (($position === 0 && $showContent) ? '-16px' : '0.5rem')};
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h2`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: left;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
  padding: 0;
`;

export const TextContent = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.94px;
  text-align: left;
  color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const ExpandButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 24px;
  height: 24px;
  border: none;
  cursor: pointer;
  font-size: 20px;
  outline: none;
  padding: 0;
  margin: 0;
  cursor: pointer;

  &:hover {
    background-color: transparent;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  transition: height 0.2s ease-in-out;
`;

export const Form = styled.form<{ $showContent: boolean }>`
  display: flex;
  gap: 8px;
  padding-top: 12px;
  animation: ease-out, ${fadeIn} 0.5s ease-out;
`;

export const InputForm = styled.input`
  width: 100%;
  gap: 16px;
  border-radius: 8px;
  opacity: 0px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: 8px 12px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.primary};
  outline: none;
  box-sizing: border-box;
`;

export const ButtonForm = styled.button`
  width: 100%;
  max-width: 100px;
  border-radius: 4px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.inverted};
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.error};
  margin-top: 4px;
  margin-left: 8px;
`;

export const WrapperToggleShowInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const AppliedItem = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.94px;
  text-align: right;
  color: ${({ theme }) => theme.colors.info};
  min-width: 120px;
`;

export const HorizontalLine = styled.hr`
  border: 1px solid ${({ theme }) => theme.colors.border};
  margin: 8px 0 0 0;
`;
